import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Panel, StatusBadge } from "@/components/kit";

const TABS = [
  { key: "purchase-orders", title: "Purchase Orders", cols: [["po_number", "PO #"], ["supplier", "Supplier"], ["status", "Status"], ["total", "Total"], ["order_date", "Ordered"]] },
  { key: "goods-receipts", title: "Goods Receipts", cols: [["receipt_number", "Receipt #"], ["supplier", "Supplier"], ["status", "Status"], ["received_date", "Received"]] },
  { key: "shipments", title: "Shipments", cols: [["shipment_number", "Shipment #"], ["customer", "Customer"], ["status", "Status"], ["dispatch_date", "Dispatch"]] },
];

export default function Finance() {
  const [active, setActive] = useState(0);
  const [rows, setRows] = useState([]);
  const tab = TABS[active];
  useEffect(() => {
    let ok = true;
    api.get(`/finance/${tab.key}`).then(({ data }) => ok && setRows(data)).catch(() => ok && setRows([]));
    return () => { ok = false; };
  }, [active, tab.key]);

  const cell = (r, k) => {
    if (k === "status") return <StatusBadge status={r[k]} />;
    if (k === "total") return r[k] != null ? Number(r[k]).toLocaleString() : "—";
    if (k.endsWith("_date")) return r[k] ? String(r[k]).slice(0, 10) : "—";
    return r[k] ?? "—";
  };

  return (
    <div className="space-y-6" data-testid="finance-page">
      <PageHeader title="Finance" subtitle="Read-only oversight of financial activity across the operation." />
      <div className="flex gap-2 border-b border-slate-800 pb-3" data-testid="finance-tabs">
        {TABS.map((t, i) => (
          <button key={t.key} onClick={() => setActive(i)} data-testid={`finance-tab-${t.key}`}
            className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${i === active ? "bg-orange-600/15 text-orange-400 border border-orange-600/30" : "text-slate-400 hover:text-slate-100"}`}>
            {t.title}
          </button>
        ))}
      </div>
      <Panel className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left font-mono text-[11px] uppercase tracking-wider text-slate-500 border-b border-slate-800">
            {tab.cols.map(([k, l]) => <th key={k} className="px-4 py-3">{l}</th>)}
          </tr></thead>
          <tbody>{rows.length === 0 ? <tr><td colSpan={tab.cols.length} className="px-4 py-8 text-center text-slate-500">No records.</td></tr>
            : rows.map((r, idx) => (<tr key={idx} className="border-b border-slate-800/60">
              {tab.cols.map(([k]) => <td key={k} className="px-4 py-3 font-mono text-slate-300">{cell(r, k)}</td>)}
            </tr>))}</tbody>
        </table>
      </Panel>
    </div>
  );
}
